import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { NotificationStateData } from './types';

const initialState: NotificationStateData = {
	data: { data: [], error: null },
	loading: false,
	error: '',
};

export const fetchNotification = createAsyncThunk('api/fetchNotification', (action: string) =>
	api.fetchNotification(action),
);

const notificationSlice = createSlice({
	name: 'notification',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchNotification.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchNotification.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload;
				state.error = '';
			})
			.addCase(fetchNotification.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка загрузки данных';
			});
	},
});

export default notificationSlice.reducer;
